// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ScheduleFilledSvg from "@fishx/icons-svg/es/asn/ScheduleFilled";
import FishxIcon from '../components/FishxIcon';

var ScheduleFilled = function ScheduleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ScheduleFilledSvg
  }));
};

ScheduleFilled.displayName = 'ScheduleFilled';
export default React.forwardRef(ScheduleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ScheduleFilled.js
// module id = 4068
// module chunks = 0